import { useCallback, useEffect, useState } from 'react'

import { MEASURE_SYSTEM } from '../constants/local-storage'
import {
  readFromLocalStorage,
  saveToLocalStorage,
} from '../helpers/local-storage'
import { getDefaultUnitSystem, getAvailableUnitSystems } from '../helpers/units'

const AVAILABLE_MEASURE_UNITS = getAvailableUnitSystems()
const DEFAULT_UNIT_SYSTEM = getDefaultUnitSystem()

const useMeasureSystem = () => {
  const [measureSystem, _setMeasureSystem] = useState(DEFAULT_UNIT_SYSTEM)

  const setMeasureSystem = useCallback((value) => {
    if (AVAILABLE_MEASURE_UNITS.includes(value)) {
      _setMeasureSystem(value)
      saveToLocalStorage(MEASURE_SYSTEM, value)
    }
  }, [])

  useEffect(() => {
    const storedMeasureSystem = readFromLocalStorage(MEASURE_SYSTEM)
    if (storedMeasureSystem && measureSystem !== storedMeasureSystem) {
      setMeasureSystem(storedMeasureSystem)
    }
  }, [measureSystem, setMeasureSystem])

  return { measureSystem, setMeasureSystem }
}

export default useMeasureSystem
